<template>
    <div class="align-text-bottom">
        <label class="leading-none mr-2">Sort By:</label>
        <div class="form-check-inline mr-2">
            <input v-model="sortBy" id="sortByCategoryLabel" type="radio" value="defaultSort" class="form-check-input mr-[0.325rem]" />
            <label for="sortByCategoryLabel" class="form-check-label">Category</label>
        </div>
        <div class="form-check-inline">
            <input v-model="sortBy" id="sortBySymbolLabel" type="radio" value="sortBySymbol" class="form-check-input mr-[0.325rem]" />
            <label for="sortBySymbolLabel" class="form-check-label">Alphabetically</label>
        </div>
    </div>
</template>

<script setup>
import { ref, watch, onMounted, inject } from 'vue';
import { useLocationHash } from '../../mixins/LocationHash';

const props = defineProps({
    sort: {
        type: [Object, String],
        default: () => ({
            groupBy: 'uscCategory.symbolName',
        })
    },
    modelValue: {
        type: String,
        default: null,
    },
});

const emit = defineEmits();
const { hashExists, searchHash, addToHash } = useLocationHash();
const eventBus = inject('eventBus');

const defaultSort = { groupBy: 'uscCategory.symbolName' };
const sortBySymbol = { groupBy: 'symbolName', orderBy: 'symbolName', orderDir: 'asc' };
const sortBy = ref('defaultSort');

function getFromHash() {
    if (hashExists()) {
        const currentHash = searchHash('sortBy');
        if (currentHash && currentHash.value === 'symbol') {
            return 'sortBySymbol';
        }
    }
}

function updateSort(value) {
    if (value != null) {
        eventBus.emit('sortBy', value === 'defaultSort' ? defaultSort : sortBySymbol);
        const hashValue = value === 'defaultSort' ? 'category' : 'symbol';
        addToHash('sortBy', hashValue);
        emit('update:modelValue', value);
    }
}

watch(sortBy, (newValue) => {
    updateSort(newValue);
});

onMounted(() => {
    const hashSortBy = getFromHash();
    if (hashSortBy) {
        sortBy.value = hashSortBy;
    } else if (props.modelValue) {
        sortBy.value = props.modelValue;
    }
});
</script>
